interface IsAccommodationV2BookingParams {
  property: Pick<App.Property.Property, 'accommV2Bookable'>
  isLoggedIn: boolean
  isAccommodationV2BookingsEnabled: boolean
}

/**
 * Single gate for the accommodationV2 SPP checkout path.
 *
 * All of the following must be true:
 * - the `spp_accommodation_v2_bookings` feature flag is enabled
 * - property.accommV2Bookable (svc-accommodation content)
 * - customer is logged in (enquiry-session create requires auth)
 *
 * When false, callers must fall through to the legacy hotel / bedbankHotel path.
 */
export function isAccommodationV2Booking({
  property,
  isLoggedIn,
  isAccommodationV2BookingsEnabled,
}: IsAccommodationV2BookingParams): boolean {
  return isAccommodationV2BookingsEnabled && !!property.accommV2Bookable && isLoggedIn
}
